import {
    NinchatActionType,
    NinchatCreateCommentAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const createComment = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatCreateCommentAction}`,
    async (arg: NinchatActionParams<NinchatCreateCommentAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatCreateCommentAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
